import { gql } from '@apollo/client';

export const qualityReturnPictureListQuery = gql`
  query ($personId: Int!, $returnReceiptId: Int!) {
    getReturnReceiptPicturesURL(personId: $personId, returnReceiptId: $returnReceiptId) {
      objectKey
      objectURL
    }
  }
`;
